$(document).ready(function () {

	// WYSIWYG
	// Pfad zu den Icons setzen
	$.trumbowyg.svgPath = '/fileadmin/templates/js/trumbowyg/dist/ui/icons.svg';

	function getCustomDeep(object, propertyParts) {
	   var mainProperty = propertyParts.shift(),
		   otherProperties = propertyParts;

	   if (object !== null) {
		   if (otherProperties.length === 0) {
			   return object[mainProperty];
		   }

		   if (typeof object === 'object') {
			   return getDeep(object[mainProperty], otherProperties);
		   }
	   }
	   return object;
   }

	if ($('.ttgAnfrageBug').length) {
		var elementID = $('.ttgAnfrageBug').attr('data-uid');
		$('#anfrage' + elementID).trumbowyg({
			lang: 'de',
			btns: [
				['viewHTML'],
				['formatting'],
				['strong', 'em'],
				['upload'],
				['unorderedList', 'orderedList'],
				['removeformat'],
				['fullscreen']
			],
			semantic: false,
			autogrow: true,
			imageWidthModalEdit: true,
			plugins: {
				upload: {
					serverPath: 'https://jira-upload.ttg.at',
					fileFieldName: 'anfrage',
					urlPropertyName: 'responseUrl',
					success: function(data, trumbowyg, $modal, values) {
						if (data.error) {
							trumbowyg.addErrorOnModalField(
								$('input[type=file]', $modal),
                                "Bild zu groß (2MB)"
							);
							trumbowyg.$c.trigger('tbwuploaderror', [trumbowyg, data]);
						}
						if (data.success) {
							if (!!getCustomDeep(data, trumbowyg.o.plugins.upload.statusPropertyName.split('.'))) {
								var url = getCustomDeep(data, trumbowyg.o.plugins.upload.urlPropertyName.split('.'));
								trumbowyg.execCmd('insertImage', url);
								var $img = $('img[src="' + url + '"]:not([alt])', trumbowyg.$box);
								$img.attr('alt', values.alt);
								if (trumbowyg.o.imageWidthModalEdit && parseInt(values.width) > 0) {
									$img.attr({
										width: values.width
									});
								}
								setTimeout(function () {
									trumbowyg.closeModal();
								}, 250);
								trumbowyg.$c.trigger('tbwuploadsuccess', [trumbowyg, data, url]);
							} else {
								trumbowyg.addErrorOnModalField(
									$('input[type=file]', $modal),
									trumbowyg.lang[data.message]
								);
								trumbowyg.$c.trigger('tbwuploaderror', [trumbowyg, data]);
							}
						}
					}
				}
			}
		});
	}

	// BROWSER DETECTION
	var $browser = null;

	$browser = getBrowserVersion();
	$(".ttgBrowserVersion").html("Sie verwenden derzeit den Browser: <strong>" + $browser.join(" ") + "</strong><br /><a id='setBrowserVersion' href='#'><i class='fas fa-paste'></i> &nbsp;übernehmen</a>");
	$('.ttgBrowserVersion').on('click', '#setBrowserVersion', function (e) {
		e.preventDefault();
		setBrowserVersion($browser);
	});

});

function setBrowserVersion($browser) {
	$("#browserversion").val($browser[1]);
	$browserproduct = $browser[0];
	if ($browserproduct == "MSIE") {
		$browserproduct = "Internet Explorer";
	}
	$found = false;
	$("#browser option").filter(function () {
		if ($(this).text() == $browserproduct) {
			$found = true;
			return true;
		} else {
			return false;
		}
	}).attr('selected', true);
	if (!$found) {
		$("#browser option").filter(function () {
			if ($(this).text() == "Sonstiger Browser") {
				return true;
			} else {
				return false;
			}
		}).attr('selected', true);
	}
}

function getBrowserVersion() {

	var nVer = navigator.appVersion;
	var nAgt = navigator.userAgent;
	var browserName = navigator.appName;
	var fullVersion = '' + parseFloat(navigator.appVersion);
	var majorVersion = parseInt(navigator.appVersion, 10);
	var nameOffset, verOffset, ix;

	// In Opera, the true version is after "Opera" or after "Version"
	if ((verOffset = nAgt.indexOf("Opera")) != -1) {
		browserName = "Opera";
		fullVersion = nAgt.substring(verOffset + 6);
		if ((verOffset = nAgt.indexOf("Version")) != -1)
			fullVersion = nAgt.substring(verOffset + 8);
	}


	// In MSIE, the true version is after "MSIE" in userAgent
	else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
		browserName = "Microsoft Internet Explorer";
		fullVersion = nAgt.substring(verOffset + 5);
	}

	// In Edge, the true version is after "Edge" in userAgent
	else if ((verOffset = nAgt.indexOf("Edge")) != -1) {
		browserName = "Edge";
		fullVersion = nAgt.substring(verOffset + 5);
	}

	// In Chrome, the true version is after "Chrome"
	else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
		browserName = "Chrome";
		fullVersion = nAgt.substring(verOffset + 7);
	}

	// In Safari, the true version is after "Safari" or after "Version"
	else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
		browserName = "Safari";
		fullVersion = nAgt.substring(verOffset + 7);
		if ((verOffset = nAgt.indexOf("Version")) != -1)
			fullVersion = nAgt.substring(verOffset + 8);
	}

	// In Firefox, the true version is after "Firefox"
	else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
		browserName = "Firefox";
		fullVersion = nAgt.substring(verOffset + 8);
	}

	// In most other browsers, "name/version" is at the end of userAgent
	else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
			(verOffset = nAgt.lastIndexOf('/')))
	{
		browserName = nAgt.substring(nameOffset, verOffset);
		fullVersion = nAgt.substring(verOffset + 1);
		if (browserName.toLowerCase() == browserName.toUpperCase()) {
			browserName = navigator.appName;
		}
	}

	// trim the fullVersion string at semicolon/space if present
	if ((ix = fullVersion.indexOf(";")) != -1)
		fullVersion = fullVersion.substring(0, ix);
	if ((ix = fullVersion.indexOf(" ")) != -1)
		fullVersion = fullVersion.substring(0, ix);

	majorVersion = parseInt('' + fullVersion, 10);
	if (isNaN(majorVersion)) {
		fullVersion = '' + parseFloat(navigator.appVersion);
		majorVersion = parseInt(navigator.appVersion, 10);
	}

	return [browserName, fullVersion];

}